import { render, staticRenderFns } from "./MainHeaderBreadcrumbs.vue?vue&type=template&id=53338806&"
import script from "./MainHeaderBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./MainHeaderBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports